module.exports = __webpack_public_path__ + "img/map-marker-blue.aa7ac29e.svg";